<app-menu-acessibilidade/>
<app-menu tabindex="-1" id="menu2" [currentRoute]="currentRoute"/>
<div class="main-content" tabindex="-1">
  <div class="loading-content" *ngIf="isLoading">
    <div class="loading-content-image flex flex-col items-center">
      <img src="assets/ilustrations/loading-circle.png" alt="loading" class="mb-2" />
      <ng-container *ngFor="let mensagem of mensagensCarregamento">
        <span class="text-charcoal-800 text-body-xlg">{{mensagem}}</span>
      </ng-container>
    </div>
  </div>

  <div class="page-content">
    <router-outlet id="conteudo"/>
  </div>

  <app-parceiros />
  <app-rodape id="footer" tabindex="-1" />
</div>
